import {
  AppBar,
  Box,
  Button,
  Grid,
  TablePagination,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useReducer } from 'react';
import AddIcon from '@material-ui/icons/Add';
import SendIcon from '@material-ui/icons/SendRounded';
import AttachFile from '@material-ui/icons/AttachFileRounded';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../Components/BreadCrumb';
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import routes from '../../../../Utils/routes.json';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import EditOutlined from '@material-ui/icons/EditOutlined';
import { useRef, useState } from 'react';
import KenCard from '../../../../global_components/KenCard';
import KenGrid from '../../../../global_components/KenGrid';
import KenPopover from '../../../../Components/KenPopOver';
import KenDialogBox from '../../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../../global_components/KenSelect';
import {
  RiFilterLine,
  RiCheckFill,
  RiNotification2Fill,
  RiNotification3Line,
} from 'react-icons/ri';
import Kentable from '../../../../global_components/KenTable/kentable';
import { CheckBox, Message } from '@material-ui/icons';
import KenDateTimePicker from '../../../../global_components/KenDateTimePicker';
import KenSelect from '../../../../global_components/KenSelect';
import KenLoader from '../../../../Components/KenLoader';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
// Icons
import EditIcon from '@material-ui/icons/EditOutlined';
import DoneIcon from '@material-ui/icons/DoneAllTwoTone';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';
import KenAutoComplete from '../../../../global_components/KenAutoComplete/index';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import moment from 'moment';
import ChatLayout from '../../components/ChatLayout';
import ChatInput from '../../components/ChatInput';
import KenGridEditable from '../../../../global_components/kenEditDataGrid/kenGridEditable';

import '../../../../style/index.css';
import {
  getEvaluationDetailsData,
  postEvaluationDetailsData,
  getExamModuleListData,
  facultyList,
} from '../../../../Utils/apiServices';
import { sendMailEvaluation } from '../../../../Utils/sendMail';
import TablePaginationActions from '../../../../global_components/KenGrid/TablePaginationActions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SamplePdf from '../../../../Assets/samplePdf.pdf';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useTranslation } from 'react-i18next';

// const arrayBreadCrumb = [
//   // { head: 'ADMIN PORTAL', url: routes.adminManagement },
//   {
//     head: 'EXAM',
//     url: routes.exam,
//   },
//   {
//     head: 'EVALUATION',
//   },
// ];

export const facultyDropDown = [
  { title: 'Jane Coper', year: 1994 },
  { title: 'Wade warren', year: 1972 },
  { title: 'Jane Coper', year: 1974 },
  { title: 'Wade warren', year: 2008 },
  { title: 'Wade warren', year: 1957 },
];
const ActionCellSendMessage = (row) => {
  const classes = useStyles();

  // Message Modal
  const [messageDialog, setMessageDialog] = useState(false);

  function handleMessageDialog() {
    setMessageDialog((prevState) => !prevState);
  }
  const { id } = row.row.values;

  const handleClick = () => {
    handleMessageDialog();
  };
  return (
    <>
      <Message
        style={{
          color: '#092682',
        }}
        className="m-0"
        onClick={handleClick}
      />
      {/* Message Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Message Modal
          </Typography>
        }
        open={messageDialog}
        handleClose={() => handleMessageDialog()}
        negativeButtonClick={() => handleMessageDialog()}
        positiveButtonClick={() => handleMessageDialog()}
        positiveButtonText="Send"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          {id}
        </Grid>
      </KenDialogBox>
    </>
  );
};
const editHandler = (id) => {
  console.log('Editing started', id);
};
const onToggleEditMode = (id) => {
  console.log('id', id);
};

const ActionCellEdit = (row, isUpdating) => {
  const { id } = row.row.values;
  return <EditOutlined className="m-0" onClick={() => onToggleEditMode(id)} />;
};

const CellWithButton = (row) => {
  const classes = useStyles();
  const { seating_plan, id } = row.row.values;

  // console.log({ eligibility_status });

  let classOfBtn;
  if (seating_plan === 'Generate') {
    classOfBtn = classes.Green;
  } else if (seating_plan === 'View / Edit') {
    classOfBtn = classes.Blue;
  } else {
    classOfBtn = classes.medium;
  }
  if (seating_plan === 'Generate') {
    return (
      <>
        <Box>
          <div style={{ display: 'flex' }}>
            <Button
              variant="primary"
              component={Link}
              className={classOfBtn}
              to={`${routes.seatingPlan}/arrangement/${id}`}
            >
              Generate
            </Button>
            <Button
              variant="primary"
              component={Link}
              className={classes.publishGenerate}
              // to={`${routes.currentProgrammes}/${id}/details`}
            >
              SEND
            </Button>
          </div>
        </Box>
      </>
    );
  } else {
    return (
      <>
        <Box>
          <div style={{ display: 'flex' }}>
            <Button
              variant="primary"
              component={Link}
              className={classes.Blue}
              // to={`${routes.currentProgrammes}/${id}/details`}
            >
              View / Edit
            </Button>
            <Button
              variant="primary"
              component={Link}
              className={classes.publishView}
              // to={`${routes.currentProgrammes}/${id}/details`}
            >
              SEND
            </Button>
          </div>
        </Box>
      </>
    );
  }
};

const UserCell = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%', marginRight: '10px' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    height: '28px',
    width: '78px',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    background: 'orange',
    borderRadius: '25px',
    fontSize: '10px',
    margin: '5px  5px',
    color: 'white',
    '&:hover': {
      color: 'white',
      background: 'orange',
    },
    // color: '#FFFFFF',
    // background: '#EB5757',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  normal: {
    color: 'white',
    width: '100px',
    background: 'green',

    borderRadius: '10px',
    fontSize: '12px',
    height: '35px',
    margin: '5px 5px',
    '&:hover': {
      background: 'green',

      color: 'white',
    },
    // color: '#FFFFFF',
    // background: '#27AE60',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },

  PublishButton: {
    width: '100px',
    color: 'white',
    background: '#55b0cd',
    borderRadius: '10px',
    fontSize: '12px',
    margin: '5px 5px',
    height: '35px',

    '&:hover': {
      background: '#55b0cd',
      color: 'white',
    },
  },
  publishGenerate: {
    color: '#FFFFFF',
    background: 'green',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  publishView: {
    color: '#55b0cd',
    background: 'white',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Blue: {
    color: '#FFFF',
    background: '#03248F',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Green: {
    color: '#FFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  medium: {
    color: '#FFFFFF',
    background: '#F2994A',
    width: '102px',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));

const selectOptionsFaculty = [
  {
    label: 'Select Batch',
    value: '',
  },
  {
    label: 'ken42 faculty 1',
    value: 'ken42 faculty 1',
  },
  {
    label: 'ken42 faculty 2',
    value: 'ken42 faculty 2',
  },
  {
    label: 'ken42 faculty 3',
    value: 'ken42 faculty 3',
  },
  {
    label: 'ken42 faculty 4',
    value: 'ken42 faculty 4',
  },
  {
    label: 'ken42 faculty 5',
    value: 'ken42 faculty 5',
  },
];

const selectOptionsSubject = [
  {
    label: 'Select Subject',
    value: '--Select--',
  },
  {
    label: 'Subject 1',
    value: '1',
  },
  {
    label: 'Subject 2',
    value: '2',
  },
];

const selectOptionsStatus = [
  {
    label: 'Select Date',
    value: '',
  },
  {
    label: 'Approved',
    value: 'Approved',
  },
  {
    label: 'Under process',
    value: 'Under process',
  },
  {
    label: 'Submitted',
    value: 'Submitted',
  },
];

const selectOptionsDuration = [
  {
    label: 'Select Duration',
    value: '--Select--',
  },
  {
    label: 'Duration 1',
    value: '1',
  },
  {
    label: 'Duration 2',
    value: '2',
  },
];
const selectOptionsAllocatedFaculty = [
  {
    label: 'Select Batch',
    value: '',
  },
  {
    label: 'ken42 faculty 1',
    value: 'ken42 faculty 1',
  },
  {
    label: 'ken42 faculty 2',
    value: 'ken42 faculty 2',
  },
  {
    label: 'ken42 faculty 3',
    value: 'ken42 faculty 3',
  },
  {
    label: 'ken42 faculty 4',
    value: 'ken42 faculty 4',
  },
  {
    label: 'ken42 faculty 5',
    value: 'ken42 faculty 5',
  },
];

const UserCellBulkMessage = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const sendBulkDataGrid = [
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Raleigh Avieson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Fleur Fowler'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Nealy Leitch'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Carolyne Angrock'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Abeu Aiers'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Penny Scrivinor'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Grier Laverick'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Dur Leile'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Claudine Owenson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Stefa True'
    ),
  },
];

const Evalution = () => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState('25-02-2022');
  const [startTime, setStartTime] = useState('10: 45');
  const [previous, setPrevious] = useState({});
  const [linkState, setLinkState] = useState('Link');
  const [examDate, setExamDate] = useState('');
  const [deadlineDate, setDeadlineDate] = useState('');
  const [loading, setLoading] = useState(false);
  // Filter State
  const [filterData, setFilterData] = useState();

  const [examMonthData, setExamMonthData] = useState([]);
  const [selectCourseData, setselectCourseData] = useState([]);
  const [selectTermData, setselectTermData] = useState([]);
  const [selectCampusData, setselectCampusData] = useState([]);
  const [totalData, setTotalData] = useState(25);
  const [selectFacultyData, setselectFacultyData] = useState([]);

  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [facultyDrop, setFacultyDrop] = useState({});
  const [selectValueDuration, setSelectValueDuration] = useState(
    selectOptionsDuration[0].value
  );
  const chatData = [
    {
      sender: true,
      message: `Hey, Could you please let me know which chapters I have to cover
    in UX/UI paper?`,
      profilePic: 'https://ptetutorials.com/images/user-profile.png',
      time: '3 days ago',
    },
    {
      sender: false,
      message: `Hi Nandhini, you should include first 8 chapters in mid semester
      exam.`,
      profilePic: '',
      time: '3 days ago',
    },
    {
      sender: true,
      message: `Okay, Thank you gentleman!`,
      profilePic: 'https://ptetutorials.com/images/user-profile.png',
      time: '3 days ago',
    },
  ];
  const [chats, setChats] = useState(chatData);
  const [typedMessage, setTypedMessage] = useState(
    'Anytime, You are always welcome!'
  );
  const onToggleEditMode = (id) => {
    setRows((state) => {
      return rows.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  const messageChangeHandler = (e) => {
    setTypedMessage(e.target.value);
  };

  const selectOptionsBatch = [
    {
      label: 'Select Batch',
      value: '',
    },
    {
      label: 'February',
      value: 'February',
    },
    {
      label: 'April',
      value: 'April',
    },
    {
      label: 'October',
      value: 'October',
    },
    {
      label: 'December',
      value: 'December',
    },
  ];
  const sendMessageHandler = () => {
    if (!typedMessage) {
      return;
    }

    setChats((prev) => {
      return [
        ...prev,
        {
          sender: false,
          message: typedMessage,
          profilePic: '',
          time: moment(new Date()).fromNow(),
        },
      ];
    });

    setTypedMessage('');
  };
  const onChange = (e, row) => {
    console.log('erow', e, row);
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };

  const onToggleEdit = (id, rowes) => {
    setRows((state) => {
      return rowes.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  // const onRevert = (id) => {
  //   const newRows = rows.map((row) => {
  //     if (row.id === id) {
  //       return row;
  //     }
  //     return row;
  //   });
  //   setRows(newRows);
  //   setPrevious((state) => {
  //     delete state[id];
  //     return state;
  //   });
  //   onToggleEdit(id, newRows);
  // };
  const onRevert = (id) => {
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return previous[id] ? previous[id] : row;
      }
      return row;
    });
    setRows(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
    onToggleEdit(id, newRows);
  };

  const [rows, setRows] = useState([]);
  let ab = useParams();
  // const [searchParams] = useSearchParams();
  const location = useLocation();
  const params = window.location.search;
  const myArray = params.split('course=');
  console.log('userIduserIduserIduserId', myArray[1]);

  const [selectValueCourse, setSelectValueCourse] = useState(
    myArray[1] ? myArray[1] : ''
  );
  const handleSelectChangeCampus = (e) => {
    setSelectValueCourse(e.target.value);
  };

  const [selectValueTerm, setSelectValueTerm] = useState('');
  const handleSelectChangeTerm = (e) => {
    setSelectValueTerm(e.target.value);
    setSelectValueCourse('');
  };

  const [selectValueStatus, setSelectValueStatus] = useState(
    selectOptionsStatus[0].value
  );

  const handleSelectChangeStatus = (e) => {
    setSelectValueStatus(e.target.value);
  };

  const [selectValueFaculty, setSelectValueFaculty] = useState(
    selectOptionsFaculty[0].value
  );
  const handleSelectChangeFaculty = (e) => {
    setSelectValueFaculty(e.target.value);
  };

  const [selectValueSubject, setSelectValueSubject] = useState(
    selectOptionsSubject[0].value
  );
  const handleSelectChangeSubject = (e) => {
    setSelectValueSubject(e.target.value);
  };
  const [selectValueBatch1, setSelectValueBatch1] = useState([]);

  const [selectValueBatch, setSelectValueBatch] = useState('');
  const handleSelectChangeBatch = (e) => {
    setSelectValueBatch(e.target.value);
  };
  const [selectValueExamCycle1, setSelectValueExamCycle1] = useState([]);

  const [selectValueExamCycle, setSelectValueExamCycle] = useState('');
  const handleSelectChangeExamCycle = (e) => {
    setSelectValueExamCycle(e.target.value);
  };

  const [selectValueAllocated, setSelectValueAllocated] = useState();
  const FacultyData = () => {
    facultyList().then((res) => {
      console.log('facultyListfacultyListfacultyList', res);

      const fdata = res?.map((item) => {
        return { label: item.facultyName, value: item.facultyName };
      });
      setSelectValueAllocated(fdata);
    });
  };

  const handleSelectChangeAllocated = (e) => {
    setSelectValueAllocated(e.target.value);
  };

  const [selectValueAlloctedFaculty, setSelectValueAlloctedFaculty] = useState(
    selectOptionsAllocatedFaculty[0].value
  );

  const handleSelectChangeAlloctedFaculty = (e) => {
    setSelectValueAlloctedFaculty(e.target.value);
  };

  const handleSelectChangeDuration = (e) => {
    setSelectValueDuration(e.target.value);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [filterDialog, setFilterDialog] = useState(false);

  function handleFilterDialog() {
    setFilterDialog((prevState) => !prevState);
  }

  const [sendBulkMessageDialog, setSendBulkMessageDialog] = useState(false);

  function handleSendBulkMessageDialog() {
    setSendBulkMessageDialog((prevState) => !prevState);
  }

  const [selectAllData, setSelectAllData] = useState(false);

  const handleSelectRow = (evt, row, index) => {
    // TODO code here to perform actions on selecting row in table
  };

  const handleSelectAllRows = (state) => {
    // TODO code here to perform actions on selecting all rows in table
    setSelectAllData(state);
  };

  const manageExamDate = (e, row) => {
    setExamDate(e.target.value);
  };

  const manageDeadLineDate = (e, row) => {
    setDeadlineDate(e.target.value);
  };

  const manageStartTime = (e, row) => {
    setStartTime(e.target.value);
  };
  const venueCell = (row) => {
    // const { num } = row.row.values;
    return (
      <Box>
        <KenSelect
          name="faculty"
          options={facultyDropDown}
          value={facultyDrop.faculty}
          dropdownColor="#ffffff"
          onChange={(e, row) =>
            setFacultyDrop({
              ...facultyDrop,
              [e.target.name]: e.target.value,
            })
          }
          required={true}
        />
      </Box>
    );
  };

  // Editing
  // const [dataOfTable, setDataOfTable] = useState(data);
  const [isEditing, setIsEditing] = useState(false);
  const [messageDialog, setMessageDialog] = useState(false);
  function handleMessageDialog() {
    setMessageDialog((prevState) => !prevState);
  }
  const handleClickDialoge = () => {
    handleMessageDialog();
  };
  const [respData, setRespData] = useState({});
  const onDataSave = () => {
    setLoading(true);
    console.log('object');
    const newData = [...rows];

    const payload = newData.map((row) => {
      console.log('rowrowrowrowrowrowrowrow', row);
      return {
        id: row.id,
        allocatedTo: row.allocatedTo ? row.allocatedTo : null,
        deadline: row.deadline ? row.deadline : null,
        // status: row.status,
        sendEmail: false,
      };
    });
    setLoading(true);
    postEvaluationDetailsData(payload)
      .then((res) => {
        setLoading(true);
        setRespData(res);
        toast.success(`${res.message}`);
        getEvaluationDetailsDataListing();
      })
      .catch((err) => {
        setLoading(true);
        toast.error(`${err}`);
      });
    setLoading(true);
  };

  useEffect(() => {
    if (respData.success === 'true') {
      sendMailEvaluation();
    }
  }, [respData]);

  useEffect(() => {
    getExamModuleListData().then((res) => {
      setFilterData(res);
    });
  }, []);

  useEffect(() => {
    let TermListData = filterData?.TermList.map((item) => {
      return {
        label: item.TermName,
        value: item.TermName,
      };
    });
    setselectTermData(TermListData);

    // For Course
    let CourseListData = filterData?.CourseList.filter((item) => {
      return (
        selectValueTerm == item.TermName && item.TermName && item.CourseName
      );
    }).map((item) => {
      return {
        label: item.CourseName,
        value: item.CourseName,
      };
    });

    setselectCourseData(CourseListData);

    // For Faculty
    let FacultyListData = filterData?.courseFacultyList
      .filter((item) => {
        console.log('item---Fac', item);
        return selectValueCourse === item.CourseName;
      })
      .map((itemss) => {
        let Fcaulty = itemss?.FacultyName?.map((item) => {
          return {
            label: item,
            value: item,
          };
        });

        return Fcaulty;
        // setselectFacultyData1(Fcaulty);
      });
    setselectFacultyData(FacultyListData);

    //For Campus
    let CampusListData = filterData?.campus.map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    setselectCampusData(CampusListData);
    let BatchListData = filterData?.batchList
      .filter((item) => {
        return item != null;
      })
      .map((item) => {
        return {
          label: item,
          value: item,
        };
      });
    setSelectValueBatch1(BatchListData);

    let ExamCycleListData = filterData?.ExamMonthList.filter((item) => {
      return item != null;
    }).map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    setSelectValueExamCycle1(ExamCycleListData);
  }, [filterData, selectValueTerm, selectValueCourse]);

  //Pagination

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const onClickPublish = (id) => {
  //   const filter = {
  //     id: id,
  //   };
  //   let email = [];

  //   getInvigilator_s2_Data(filter)
  //     .then((res) => {
  //       res[0].facultyList.map((itemData) => {
  //         console.log('itemDataitemDataitemData', itemData);

  //         if (
  //           itemData.allocatedRoomNo !== '' &&
  //           itemData.isAllocated === 'Assigned'
  //         ) {
  //           const payload = [
  //             {
  //               Id: id,
  //               sendEmail: true,
  //               body: 'Type body here',
  //               subject: 'Invligation should be publish',
  //               toAddresses: itemData.facEmail,
  //             },
  //           ];

  //           publishExamforInvigilation(payload)
  //             .then((res) => {})
  //             .catch((err) => {
  //               console.log('erroror', err);
  //             });
  //         }
  //       });

  //       // const assignedFacultyEmailIds = email.filter((item) => {
  //       //   return item != null;
  //       // });

  //       // const payload = [
  //       //   {
  //       //     Id: id,
  //       //     sendEmail: true,
  //       //     body: 'Type body here',
  //       //     subject: 'Invligation should be publish',
  //       //     toAddresses: assignedFacultyEmailIds,
  //       //   },
  //       // ];

  //       // publishExamforInvigilation(payload)
  //       //   .then((res) => {})
  //       //   .catch((err) => {
  //       //     console.log('erroror', err);
  //       //   });
  //     })
  //     .catch((err) => {
  //       console.log('erroror', err);
  //     });
  // };

  const getAllData = () => {
    history.push(`/app/exam/evaluation`);
    setLoading(true);
    let filterData = {
      course: '',
      status: '',
      deadline: '',
      dateOfExam: '',
      subjectFaculty: '',
      allocatedTo: '',
      batch: '',
      examCycle: '',
    };
    getEvaluationDetailsData(filterData).then((res) => {
      setLoading(false);
      const EvaluationDetailsInfo =
        res?.gradingInfoList === null
          ? []
          : res?.gradingInfoList.map((item, index) => {
              console.log('itemitem', item);
              return {
                id: item.id,
                course: item.courseName ? item.courseName : '',
                examDate: item.dateTimeofExam ? item.dateTimeofExam : '',
                faculty: item.subjectFaculty ? item.subjectFaculty : '',
                allocatedTo: item.allocatedTo ? item.allocatedTo : '',
                deadline: item.deadline ? item.deadline : '',
                status: item.status ? item.status : '',
                batch: item.batch ? item.batch : '',
                examCycle: item.examCycle ? item.examCycle : '',
              };
            });
      setTotalData(res.noOfRecords);
      setRows(EvaluationDetailsInfo);
      setFilterDialog(false);
      setLoading(false);
    });
  };

  const getEvaluationDetailsDataListing = () => {
    setLoading(true);
    let filterData = {
      course: selectValueCourse,
      status: selectValueStatus,
      deadline: deadlineDate,
      dateOfExam: examDate,
      subjectFaculty: selectValueFaculty,
      allocatedTo: selectValueAlloctedFaculty,
      batch: selectValueBatch,
      examCycle: selectValueExamCycle,
      pageNo: page,
      count: rowsPerPage,
    };
    getEvaluationDetailsData(filterData).then((res) => {
      setLoading(false);
      console.log('resForStudentStatus', res);
      const EvaluationDetailsInfo =
        res?.gradingInfoList === null
          ? []
          : res?.gradingInfoList.map((item, index) => {
              console.log('itemitem', item);
              return {
                id: item.id,
                course: item.courseName ? item.courseName : '',
                examDate: item.dateTimeofExam ? item.dateTimeofExam : '',
                faculty: item.subjectFaculty ? item.subjectFaculty : '',
                allocatedTo: item.allocatedTo ? item.allocatedTo : '',
                deadline: item.deadline ? item.deadline : '',
                status: item.status ? item.status : '',
                batch: item.batch ? item.batch : '',
                examCycle: item.examCycle ? item.examCycle : '',
                exam_type: item.typeOfExam ? item.typeOfExam : 'NA',
                termName: item.termName ? item.termName : 'NA',
              };
            });

      setRows(EvaluationDetailsInfo);
      setTotalData(res.noOfRecords);
      setFilterDialog(false);
      setLoading(false);
    });
  };
  useEffect(() => {
    getEvaluationDetailsDataListing();
    FacultyData();
  }, [page, rowsPerPage]);
  return (
    <Box>
      {loading && <KenLoader />}
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Evaluation
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            {/* <Button
              startIcon={<RiNotification3Line />}
              variant="contained"
              component={Link}
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              to={`${routes.invigilationProctoringNotification}`}
            >
              Notification
            </Button> */}
            {/* <Button
              startIcon={<GetAppIcon />}
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
            >
              <a
                href={SamplePdf}
                style={{ textDecoration: 'none', color: 'white' }}
                download
              >
                {t('labels:Report')}
              </a>
            </Button> */}
            <Button
              startIcon={<RiFilterLine />}
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              onClick={handleFilterDialog}
            >
              Filter
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              onClick={onDataSave}
            >
              Save
            </Button>
            {myArray[1] && (
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: '15px' }}
                className={classes.addButton}
                onClick={getAllData}
              >
                All Data
              </Button>
            )}
          </Grid>
        </Toolbar>
      </AppBar>

      <Box className={`cardlsitbox`}>
        <KenCard elevation={0}>
          <Table className={classes.table} aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell className="tableHeaderTitle" align="left">
                  COURSE
                </TableCell>{' '}
                <TableCell className="tableHeaderTitle" align="left">
                  TERM
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  EXAM CYCLE
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  BATCH
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  EXAM TYPE
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  DATE OF EXAM
                </TableCell>
                {/* <TableCell className="tableHeaderTitle" align="left">
                  SUBJECT FACULTY
                </TableCell> */}
                {/* <TableCell className="tableHeaderTitle" align="left">
                  ALLOCATED TO
                </TableCell> */}
                <TableCell className="tableHeaderTitle" align="left">
                  DEADLINE
                </TableCell>
                {/* <TableCell
                  className="tableHeaderTitle centerStatusTitle"
                  align="left"
                >
                  STATUS
                </TableCell> */}
                <TableCell className="tableHeaderTitle" align="left">
                  ACTION
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  EDIT
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => {
                console.log('hsdajkhsakjd', { row });
                const SetDateFormat = {
                  ...row,
                  examDate: moment(row.dateTimeofExam).format(
                    'DD-MM-YYYY HH:mm'
                  ),
                };

                return (
                  <TableRow className="editableTableRowData" key={row.id}>
                    {console.log('rowformeval', row)}
                    <KenGridEditable
                      {...{
                        row: SetDateFormat,
                        onChange,
                        columns: [
                          {
                            column_name: 'course',
                            is_inline_edit: false,
                            inline_edit_type: '',
                            label: 'course',
                          },
                          {
                            column_name: 'termName',
                            is_inline_edit: false,
                            inline_edit_type: '',
                            label: 'termName',
                          },
                          {
                            column_name: 'examCycle',
                            is_inline_edit: false,
                            inline_edit_type: '',
                            label: 'examCycle',
                          },
                          {
                            column_name: 'batch',
                            is_inline_edit: false,
                            inline_edit_type: '',
                            label: 'batch',
                          },
                          {
                            column_name: 'exam_type',
                            is_inline_edit: false,
                            inline_edit_type: '',
                            label: 'exam_type',
                          },
                          {
                            column_name: 'examDate',
                            is_inline_edit: false,
                            inline_edit_type: '',
                            label: 'examDate',
                          },
                          // {
                          //   column_name: 'faculty',
                          //   is_inline_edit: true,
                          //   inline_edit_type: '',
                          //   label: 'faculty',
                          // },
                          // {
                          //   column_name: 'allocatedTo',
                          //   is_inline_edit: true,
                          //   inline_edit_type: 'kenSelect',
                          //   dropdown: selectValueAllocated,
                          //   label: 'allocatedTo',
                          //   onChange: handleSelectChangeAllocated,
                          // },
                          {
                            column_name: 'deadline',
                            is_inline_edit: true,
                            inline_edit_type: 'kenDatePicker',
                            label: 'Deadline',
                          },
                        ],
                      }}
                    />
                    {/* {row.status === 'Under process' ? (
                      <TableCell className={classes.selectTableCell}>
                        <Box>
                          <div style={{ display: 'flex' }}>
                            <Button
                              variant="primary"
                              component={Link}
                              className={classes.error}
                              // to={`${routes.invigilationProctoring}/${id}`}
                            >
                              Under process
                            </Button>
                          </div>
                        </Box>
                      </TableCell>
                    ) : (
                      <TableCell className={classes.selectTableCell}>
                        <Box>
                          <div style={{ display: 'flex' }}>
                            <Button
                              variant="primary"
                              component={Link}
                              className={classes.normal}
                              // to={`${routes.seatingPlan}/arrangement/${id}`}
                            >
                              Completed
                            </Button>
                          </div>
                        </Box>
                      </TableCell>
                    )} */}
                    {/* chat Msg */}
                    {/* <TableCell className={classes.selectTableCell}>
                      <Box>
                        <div style={{ display: 'flex', paddingLeft: '30%' }}>
                          <Message
                            style={{
                              color: '#092682',
                              cursor: 'pointer',
                            }}
                            onClick={handleClickDialoge}
                            className="m-0"
                            // onClick={handleClick}
                          />
                        </div>
                      </Box>
                    </TableCell> */}
                    <TableCell className={classes.selectTableCell}>
                      <Box>
                        <div style={{ display: 'flex' }}>
                          <Button
                            variant="primary"
                            component={Link}
                            className={classes.PublishButton}
                            to={`${routes.evaluation}/${row.id}`}
                          >
                            Assign
                          </Button>{' '}
                          <Button
                            variant="primary"
                            // component={Link}
                            className={classes.normal}
                            // to={'#'}
                            // onClick={() => onClickPublish(row.id)}
                          >
                            SEND
                          </Button>
                        </div>
                      </Box>
                    </TableCell>{' '}
                    <TableCell className={classes.selectTableCell}>
                      {row.isEditMode ? (
                        <>
                          <IconButton
                            aria-label="done"
                            onClick={() => onToggleEditMode(row.id)}
                          >
                            <DoneIcon />
                          </IconButton>
                          <IconButton
                            aria-label="revert"
                            onClick={() => onRevert(row.id)}
                          >
                            <RevertIcon />
                          </IconButton>
                        </>
                      ) : (
                        <IconButton
                          aria-label="delete"
                          onClick={() => onToggleEditMode(row.id)}
                        >
                          <EditIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>{' '}
          <TablePagination
            rowsPerPageOptions={[25, 50, 100]}
            colSpan={6}
            count={totalData ? totalData : rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            SelectProps={{
              inputProps: { 'aria-label': 'rows per page' },
              native: true,
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </KenCard>
      </Box>

      {/* Filter Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            FILTER
          </Typography>
        }
        icon={<RiCheckFill />}
        maxWidth={'md'}
        open={filterDialog}
        handleClose={() => handleFilterDialog()}
        negativeButtonClick={() => handleFilterDialog()}
        positiveButtonClick={() => getEvaluationDetailsDataListing()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Term"
              options={selectTermData}
              value={selectValueTerm}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeTerm}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Course"
              options={selectCourseData}
              value={selectValueCourse}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeCampus}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Subject Faculty"
              options={selectFacultyData?.[0]}
              value={selectValueFaculty}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeFaculty}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label="Date of Exam"
              inputBaseRootClass={classes.kenDateTimePickerColor}
              placeholder="Date of Exam"
              value={examDate}
              type="date"
              required={true}
              defaultValue={examDate}
              onChange={manageExamDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label="Deadline"
              inputBaseRootClass={classes.kenDateTimePickerColor}
              placeholder="Deadline"
              value={deadlineDate}
              type="date"
              required={true}
              defaultValue={deadlineDate}
              onChange={manageDeadLineDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Allocated To"
              options={selectFacultyData?.[0]}
              value={selectValueAlloctedFaculty}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeAlloctedFaculty}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Status"
              options={selectOptionsStatus}
              value={selectValueStatus}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeStatus}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Batch"
              options={selectValueBatch1}
              value={selectValueBatch}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeBatch}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Exam Cycle"
              options={selectValueExamCycle1}
              value={selectValueExamCycle}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeExamCycle}
              required
            />
          </Grid>
        </Grid>
      </KenDialogBox>

      {/* Message Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Send Bulk Message
          </Typography>
        }
        open={sendBulkMessageDialog}
        handleClose={() => handleSendBulkMessageDialog()}
        negativeButtonClick={() => handleSendBulkMessageDialog()}
        positiveButtonClick={() => handleSendBulkMessageDialog()}
        positiveButtonText={<SendIcon />}
        negativeButtonText={<AttachFile />}
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Box className="cardlsitbox">
              <KenCard elevation={0}>
                <Kentable
                  data={sendBulkDataGrid}
                  initialState={{
                    hiddenColumns: ['id'],
                  }}
                  allcheckboxData={(state) => handleSelectAllRows(state)}
                  onRowCheckBox={(event, row, index) =>
                    handleSelectRow(event, row, index)
                  }
                />
              </KenCard>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box className="cardlsitbox">
              <KenCard elevation={0}>
                <TextField
                  placeholder="Add Comments"
                  multiline
                  rows={10}
                  maxRows={'Infinity'}
                />
              </KenCard>
            </Box>
          </Grid>
        </Grid>
      </KenDialogBox>
      <KenDialogBox
        title={
          <Typography
            variant="p"
            className={classes.modalHeader}
            style={{ display: 'flex', alignItems: 'center ' }}
          >
            <p>
              <img
                style={{ borderRadius: '50%', marginRight: '10px' }}
                width="40"
                height="40"
                src={'http://dummyimage.com/174x172.png/5fa2dd/ffffff'}
                alt="user"
              />
              {'Jane Cooper'}
            </p>

            <p>A - 12345</p>
            <p>Campus 1</p>
            <p>Course 1</p>
          </Typography>
        }
        open={messageDialog}
        handleClose={() => handleMessageDialog()}
        hidePositiveButton={true}
        hideNegativeButton={true}
        maxWidth="md"
        dividers
      >
        <div className="chat-box-part">
          <ChatLayout chats={chats} />

          <ChatInput
            typedMessage={typedMessage}
            messageChangeHandler={messageChangeHandler}
            sendMessageHandler={sendMessageHandler}
          />
        </div>
      </KenDialogBox>
    </Box>
  );
};

export default Evalution;
